import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TurnOffWeeklyDisclaimerPage } from './turn-off-weekly-disclaimer.page';

const routes: Routes = [
  {
    path: '',
    component: TurnOffWeeklyDisclaimerPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TurnOffWeeklyDisclaimerPageRoutingModule {}
